<template>
  <v-container id="campuses" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <base-material-card
          :title="$i18n.t('Change Email')"
          icon="mdi-cellphone-iphone"
          class="px-3 py-3 small-icon"
          color="primary"
        >
          <v-form id="form" ref="form" v-model="valid">
            <v-container>
              <v-row>
                <v-col cols="12" md="2">
                  <z-country-select
                    :label="$i18n.t('Country Code') + '*'"
                    class="purple-input"
                    v-model="profile.countryCode"
                    isd
                    hideName
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    :label="$i18n.t('Current Phone No')"
                    v-model="profile.phone"
                    disabled
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="2">
                  <z-country-select
                    :label="$i18n.t('Country Code') + '*'"
                    class="purple-input"
                    v-model="new_countryCode"
                    isd
                    hideName
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    :label="$i18n.t('New Phone No.') + '*'"
                    required
                    type="number"
                    v-model="new_phone"
                    :rules="validationrules.newPhone"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-col cols="12" md="10">
                <v-text-field
                  :label="$i18n.t('Verification Code') + '*'"
                  required
                  v-if="sendCode"
                  v-model="code"
                ></v-text-field>
              </v-col>
            </v-container>
            <v-col cols="12" class="text-right">
              <v-btn
                color="info"
                class="mr-0"
                @click="sendVeriCode()"
                :loading="loading"
                v-if="!sendCode"
                :disabled="!valid"
              >
                <h3>{{ $i18n.t("Send Code") }}</h3>
              </v-btn>
            </v-col>

            <v-col cols="12" class="text-right">
              <v-btn
                color="success"
                class="mr-0"
                @click="save()"
                :loading="loading"
                v-if="sendCode"
                :disabled="!valid"
              >
                <h3>{{ $i18n.t("Verify") }}</h3>
              </v-btn>
            </v-col>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPostForm } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Holidays extends Vue {
  url = "/api/profile/details";
  profile = {
    email: "",
  };
  sendCode = false;
  code = "";
  new_phone = "";
  new_countryCode = "";
  value = "";
  valid = true;
  validationrules = {
    newPhone: [(v) => !!v || this.$i18n.t("New Phone No is required")],
  };

  get loading() {
    return common.loading;
  }

  async mounted() {
    try {
      this.profile = await doGet(this.url);
    } catch (e) {
      common.setError(e.message);
    }
  }

  async sendVeriCode() {
    try {
      const formData = new FormData();
      formData.set("new_phone", this.new_phone);
      formData.set("new_countryCode", this.new_countryCode);
      formData.set("phone", this.profile.phone);
      formData.set("countryCode", this.profile.countryCode);

      await doPostForm("/api/user/sendchangePhoneVeriCode", formData);
      common.setLoading(false);
      common.showMessage(
        "The Verification Code has been sent to your Phone no"
      );
      this.sendCode = true;
    } catch (e) {
      common.setError(e);
      common.setLoading(false);
    }
  }

  async save() {
    try {
      const formData1 = new FormData();
      formData1.set("new_phone", this.new_phone);
      formData1.set("new_countryCode", this.new_countryCode);
      formData1.set("phone", this.profile.phone);
      formData1.set("sms_verification_code", this.code);
      formData1.set("countryCode", this.profile.countryCode);

      common.setLoading(true);

      await doPostForm("/api/user/changePhone", formData1);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e);
      common.setLoading(false);
    }
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
#bookingCheckbox {
  margin-left: 20px;
  margin-right: 20px;
  justify-content: space-between;
}
</style>
